/* Right-edge fade cue for horizontal-scroll carousels.
   Wraps any [data-scroll-fade] element and toggles a class while there's
   more content to scroll toward the right; the fade hides at the end. */
(function () {
  function init(track) {
    if (track.parentNode && track.parentNode.classList.contains('scroll-fade')) return;
    var wrap = document.createElement('div');
    wrap.className = 'scroll-fade';
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(track);

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      wrap.classList.toggle('scroll-fade--more', max > 4 && track.scrollLeft < max - 4);
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    window.addEventListener('load', update);
    update();
  }

  function run() {
    document.querySelectorAll('[data-scroll-fade]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();

/* Page scroll-progress bar (fills down the right edge as you scroll). */
(function () {
  var fill = document.querySelector('[data-scroll-progress]');
  if (!fill) return;
  var ticking = false;
  function update() {
    ticking = false;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var p = max > 0 ? (window.pageYOffset / max) : 0;
    fill.style.height = (Math.max(0, Math.min(1, p)) * 100) + '%';
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
